import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CARGO_LIST_TYPE, CARGO_STATUS, LOGON_INFO, IMPORTANCE_TYPE } from '../app.constants';
import { Cargo } from './cargo.service';
import $ from 'jquery';


@Component({
    selector: 'cargo-list',
    templateUrl: 'cargo-list.component.html'
})
export class CargoListComponent implements OnInit {

    CARGO_LIST_TYPE: any = CARGO_LIST_TYPE;
    CARGO_STATUS: any = CARGO_STATUS;
    LOGON_INFO: any = LOGON_INFO;
    IMPORTANCE_TYPE: any = IMPORTANCE_TYPE;

    @Input()
    listDiv: string;
    @Input()
    cargoList: Cargo[];
    @Input()
    totalCount: number;
    @Input()
    selectedID: number;

    table_width: string;
    table_height: string;
    status_width: string;
    col_num: number;

    @Output()
    rigthClick = new EventEmitter<Cargo>();
    @Output()
    cargoSelect = new EventEmitter<Cargo>();

    
    ngOnInit() {
        switch (this.listDiv) {
            case CARGO_LIST_TYPE.ORDER:
                this.table_width = "104.6rem";
                // this.table_height = "20rem";
                this.status_width = "4.9rem";
                this.col_num = 15;
                break;
            case CARGO_LIST_TYPE.SHIP:
                this.table_width = "128.4rem";
                // this.table_height = "20rem";
                this.status_width = "6.7rem";
                this.col_num = 20;
                break;
            case CARGO_LIST_TYPE.REQUEST:
                this.table_width = "111.4rem";
                // this.table_height = "24rem";
                this.status_width = "6.7rem";
                this.col_num = 15;
                break;
        }
    }



    onSelect(cargo: Cargo) {
        if (cargo.status == CARGO_STATUS.CANCEL || cargo.status == CARGO_STATUS.NO_ACCEPT) {
            return;
        }
        this.cargoSelect.emit(cargo);
    }


    mouseRightClick(e: any, cargo: Cargo) {
        if (cargo.status != CARGO_STATUS.NO_ACCEPT && cargo.status != CARGO_STATUS.CANCEL) {
            this.rigthClick.emit(cargo);

            $("#rightClickMenu").css({
                display: "block",
                left: e.pageX,
                top: e.pageY
           });
        }

        //falseを返して、ブラウザのcontextmenuを非表示にする
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/cargo/cargo-list.component.ts